import { defineCustomElement } from "../chunks/vidstack-D9mvYVIz.js";
import { MediaAudioLayoutElement } from "../chunks/vidstack-Cm8pcCCT.js";
import { MediaVideoLayoutElement } from "../chunks/vidstack-Drvy5CMM.js";
//#region src/elements/bundles/player-layouts/default.ts
defineCustomElement(MediaAudioLayoutElement);
defineCustomElement(MediaVideoLayoutElement);
//#endregion
